import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

const Downtime = ({ messages, loggedIn }) => {
  const formatBody = text => (
    <div>
      {text.split('\n').map(t => (
        <div style={{ marginTop: '12px' }}>{t}</div>
      ))}
    </div>
  );

  const onCloseToast = uuid => {
    const storage = localStorage.getItem('downtime');
    const readMessages = storage ? JSON.parse(storage) : [];
    localStorage.setItem('downtime', JSON.stringify([...readMessages, uuid]));
  };
  useEffect(() => {
    if (messages && messages.length && loggedIn) {
      messages.map(msg =>
        toast.error(
          <div className="">
            <h1>{msg.title}</h1>
            <p>{formatBody(msg.body)}</p>
          </div>,
          {
            position: 'top-center',
            autoClose: 100000000000,
            hideProgressBar: true,
            pauseOnHover: true,
            progress: undefined,
            onClose: () => onCloseToast(msg.uuid)
          }
        )
      );
    }
  }, [messages, loggedIn]);

  return <></>;
};

Downtime.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loggedIn: PropTypes.bool.isRequired
};

export default Downtime;
